export default "__VITE_ASSET__OKj45NWM__"